// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Standardized Sermorelin intake 6/1/26 09.17.26" (57b93fa7-8751-4c80-96ba-7af5f1b686cf). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiStandardizedSermorelinIntakeAnswerField } from './questions';

export const mdiStandardizedSermorelinIntake: FormType<mdiStandardizedSermorelinIntakeAnswerField> =
  {
    name: 'Standardized Sermorelin intake',
    validityLength: 25,
    questions: [
      'mdiStandardizedSermorelinIntake_symptomsHavingBenefittedSermorelinTreatment',
      'mdiStandardizedSermorelinIntake_injuriesSurgeriesWithinLast6',
      {
        key: 'mdiStandardizedSermorelinIntake_apply',
        next: {
          condition: {
            'mdiStandardizedSermorelinIntake_apply.current_or_history_of_glioma':
              true
          },
          key: 'mdiStandardizedSermorelinIntake_imSorryDueMedicalConditions',
          els: 'mdiStandardizedSermorelinIntake_takeMedications'
        }
      },
      'mdiStandardizedSermorelinIntake_imSorryDueMedicalConditions',
      'mdiStandardizedSermorelinIntake_takeMedications',
      'mdiStandardizedSermorelinIntake_apply2',
      'mdiStandardizedSermorelinIntake_importantClickAttachedLinkReview',
      'mdiStandardizedSermorelinIntake_elseLikeTellDoctorWho',
      'mdiStandardizedSermorelinIntake_complete'
    ]
  };
